import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import { priceTypeSchema } from "../../Validation/Validation";
const AddPriceType = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    priceTypeName: editData?.priceTypeName,
    priceTypeCode: editData?.priceTypeCode,
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? false,
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: priceTypeSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(
              `/priceType/updatePriceType/${editingId}`,
              values,
            )
          : await axiosInstance.post("/priceType/createPriceType", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/price-type");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Price Type", path: "/price-type" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Price Type
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="priceType-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="priceType-sortOrder"
                        name="sortOrder"
                        placeholder="Enter  Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="priceTypeName"
                        className="col-form-label "
                      >
                        Price Type Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="priceTypeName"
                        name="priceTypeName"
                        placeholder="Enter Price Type name"
                        value={values.priceTypeName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.priceTypeName && errors.priceTypeName && (
                        <small className="text-danger">
                          {errors.priceTypeName}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="priceTypeCode"
                        className="col-form-label "
                      >
                        Price Type Code
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="priceTypeCode"
                        name="priceTypeCode"
                        placeholder="Enter Price Type code"
                        value={values.priceTypeCode || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.priceTypeCode && errors.priceTypeCode && (
                        <small className="text-danger">
                          {errors.priceTypeCode}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/price-type">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPriceType;
